import { CurrentTab } from '@/constants/Profile.enum';
import { mockProfile } from './mock';

export default () => {
  return {
    currentTab: CurrentTab.BETTING_INFO,
    profileInfo: mockProfile,
  };
};
